import { emptyBowtieApi as api } from "../base/bowtie-api";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGlobalPrompt: build.query<
      GetGlobalPromptApiResponse,
      GetGlobalPromptApiArg
    >({
      query: () => ({ url: `/prompt/global` }),
    }),
    updateGlobalPrompt: build.mutation<
      UpdateGlobalPromptApiResponse,
      UpdateGlobalPromptApiArg
    >({
      query: (queryArg) => ({
        url: `/prompt/global`,
        method: "PUT",
        body: queryArg.globalPromptDto,
      }),
    }),
    getAllBowties: build.query<GetAllBowtiesApiResponse, GetAllBowtiesApiArg>({
      query: () => ({ url: `/record` }),
    }),
    saveBowtie: build.mutation<SaveBowtieApiResponse, SaveBowtieApiArg>({
      query: (queryArg) => ({
        url: `/record`,
        method: "POST",
        body: queryArg.bowtieDto,
      }),
    }),
    getStoredDiagramFilters: build.query<
      GetStoredDiagramFiltersApiResponse,
      GetStoredDiagramFiltersApiArg
    >({
      query: (queryArg) => ({ url: `/filters/stored/${queryArg.id}` }),
    }),
    updateStoredDiagramFilters: build.mutation<
      UpdateStoredDiagramFiltersApiResponse,
      UpdateStoredDiagramFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/filters/stored/${queryArg.id}`,
        method: "POST",
        body: queryArg.diagramFilterDto,
      }),
    }),
    deleteStoredDiagramFilters: build.mutation<
      DeleteStoredDiagramFiltersApiResponse,
      DeleteStoredDiagramFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/filters/stored/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getGeneratedDiagramFilters: build.query<
      GetGeneratedDiagramFiltersApiResponse,
      GetGeneratedDiagramFiltersApiArg
    >({
      query: (queryArg) => ({ url: `/filters/generated/${queryArg.id}` }),
    }),
    updateGeneratedDiagramFilters: build.mutation<
      UpdateGeneratedDiagramFiltersApiResponse,
      UpdateGeneratedDiagramFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/filters/generated/${queryArg.id}`,
        method: "POST",
        body: queryArg.diagramFilterDto,
      }),
    }),
    deleteGeneratedDiagramFilters: build.mutation<
      DeleteGeneratedDiagramFiltersApiResponse,
      DeleteGeneratedDiagramFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/filters/generated/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    bowtieSuggestPost: build.mutation<
      BowtieSuggestPostApiResponse,
      BowtieSuggestPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/suggest`,
        method: "POST",
        body: queryArg.bowtieCorrectionRequest,
      }),
    }),
    bowtieSuggestJobPost: build.mutation<
      BowtieSuggestJobPostApiResponse,
      BowtieSuggestJobPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/suggest/start`,
        method: "POST",
        body: queryArg.bowtieCorrectionRequest,
      }),
    }),
    bowtieHazardMueMaterialUnwantedEventsPost: build.mutation<
      BowtieHazardMueMaterialUnwantedEventsPostApiResponse,
      BowtieHazardMueMaterialUnwantedEventsPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/material-unwanted-events`,
        method: "POST",
        body: queryArg.hazardMueRequest,
      }),
    }),
    bowtieHazardMueMaterialUnwantedEventsJobPost: build.mutation<
      BowtieHazardMueMaterialUnwantedEventsJobPostApiResponse,
      BowtieHazardMueMaterialUnwantedEventsJobPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/material-unwanted-events/start`,
        method: "POST",
        body: queryArg.hazardMueRequest,
      }),
    }),
    bowtieFactorsPost: build.query<
      BowtieFactorsPostApiResponse,
      BowtieFactorsPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/factors`,
        method: "POST",
        body: queryArg.factorRequest,
      }),
    }),
    bowtieFactorsJobPost: build.mutation<
      BowtieFactorsJobPostApiResponse,
      BowtieFactorsJobPostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/factors/start`,
        method: "POST",
        body: queryArg.factorRequest,
      }),
    }),
    bowtieConvertImagePost: build.mutation<
      BowtieConvertImagePostApiResponse,
      BowtieConvertImagePostApiArg
    >({
      query: (queryArg) => ({
        url: `/ai/convert-image/start`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getBowtieById: build.query<GetBowtieByIdApiResponse, GetBowtieByIdApiArg>({
      query: (queryArg) => ({ url: `/record/${queryArg.bowtieId}` }),
    }),
    deleteBowtie: build.mutation<DeleteBowtieApiResponse, DeleteBowtieApiArg>({
      query: (queryArg) => ({
        url: `/record/${queryArg.bowtieId}`,
        method: "DELETE",
      }),
    }),
    updateBowtie: build.mutation<UpdateBowtieApiResponse, UpdateBowtieApiArg>({
      query: (queryArg) => ({
        url: `/record/${queryArg.bowtieId}`,
        method: "PATCH",
        body: queryArg.bowtieDto,
      }),
    }),
    bowtieConvertImageJobIdGet: build.query<
      BowtieConvertImageJobIdGetApiResponse,
      BowtieConvertImageJobIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/ai/convert-image/${queryArg.jobId}` }),
    }),
    bowtieJobGetById: build.query<
      BowtieJobGetByIdApiResponse,
      BowtieJobGetByIdApiArg
    >({
      query: (queryArg) => ({ url: `/ai/background-job/${queryArg.jobId}` }),
    }),
    deleteBowtieAndFilters: build.mutation<
      DeleteBowtieAndFiltersApiResponse,
      DeleteBowtieAndFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/diagram/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    deleteBowtieAndMoveFilters: build.mutation<
      DeleteBowtieAndMoveFiltersApiResponse,
      DeleteBowtieAndMoveFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/diagram/${queryArg.id}/move-filters/${queryArg.recordId}`,
        method: "DELETE",
        body: queryArg.diagramFilterDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bowtieApi };
export type GetGlobalPromptApiResponse = /** status 200 OK */ GlobalPromptDto;
export type GetGlobalPromptApiArg = void;
export type UpdateGlobalPromptApiResponse = /** status 200 OK */ boolean;
export type UpdateGlobalPromptApiArg = {
  globalPromptDto: GlobalPromptDto;
};
export type GetAllBowtiesApiResponse = /** status 200 OK */ Bowtie[];
export type GetAllBowtiesApiArg = void;
export type SaveBowtieApiResponse = /** status 200 OK */ string;
export type SaveBowtieApiArg = {
  bowtieDto: BowtieDto;
};
export type GetStoredDiagramFiltersApiResponse =
  /** status 200 OK */ DiagramFilterDto;
export type GetStoredDiagramFiltersApiArg = {
  id: string;
};
export type UpdateStoredDiagramFiltersApiResponse =
  /** status 200 OK */ boolean;
export type UpdateStoredDiagramFiltersApiArg = {
  id: string;
  diagramFilterDto: DiagramFilterDto;
};
export type DeleteStoredDiagramFiltersApiResponse =
  /** status 200 OK */ boolean;
export type DeleteStoredDiagramFiltersApiArg = {
  id: string;
};
export type GetGeneratedDiagramFiltersApiResponse =
  /** status 200 OK */ DiagramFilterDto;
export type GetGeneratedDiagramFiltersApiArg = {
  id: string;
};
export type UpdateGeneratedDiagramFiltersApiResponse =
  /** status 200 OK */ boolean;
export type UpdateGeneratedDiagramFiltersApiArg = {
  id: string;
  diagramFilterDto: DiagramFilterDto;
};
export type DeleteGeneratedDiagramFiltersApiResponse =
  /** status 200 OK */ boolean;
export type DeleteGeneratedDiagramFiltersApiArg = {
  id: string;
};
export type BowtieSuggestPostApiResponse = /** status 200 OK */ SuggestResponse;
export type BowtieSuggestPostApiArg = {
  bowtieCorrectionRequest: BowtieCorrectionRequest;
};
export type BowtieSuggestJobPostApiResponse = /** status 200 OK */ string;
export type BowtieSuggestJobPostApiArg = {
  bowtieCorrectionRequest: BowtieCorrectionRequest;
};
export type BowtieHazardMueMaterialUnwantedEventsPostApiResponse =
  /** status 200 OK */ HazardMuePair[];
export type BowtieHazardMueMaterialUnwantedEventsPostApiArg = {
  hazardMueRequest: HazardMueRequest;
};
export type BowtieHazardMueMaterialUnwantedEventsJobPostApiResponse =
  /** status 200 OK */ string;
export type BowtieHazardMueMaterialUnwantedEventsJobPostApiArg = {
  hazardMueRequest: HazardMueRequest;
};
export type BowtieFactorsPostApiResponse = /** status 200 OK */ Detail;
export type BowtieFactorsPostApiArg = {
  factorRequest: FactorRequest;
};
export type BowtieFactorsJobPostApiResponse = /** status 200 OK */ string;
export type BowtieFactorsJobPostApiArg = {
  factorRequest: FactorRequest;
};
export type BowtieConvertImagePostApiResponse = /** status 200 OK */ string;
export type BowtieConvertImagePostApiArg = {
  body: {
    image_file: Blob;
    control_types?: string;
    extra_prompt?: string;
  };
};
export type GetBowtieByIdApiResponse = /** status 200 OK */ Bowtie;
export type GetBowtieByIdApiArg = {
  bowtieId: string;
};
export type DeleteBowtieApiResponse = /** status 200 OK */ boolean;
export type DeleteBowtieApiArg = {
  bowtieId: string;
};
export type UpdateBowtieApiResponse = /** status 200 OK */ boolean;
export type UpdateBowtieApiArg = {
  bowtieId: string;
  bowtieDto: BowtieDto;
};
export type BowtieConvertImageJobIdGetApiResponse =
  /** status 200 OK */ BackgroundJobConvertImageResponse;
export type BowtieConvertImageJobIdGetApiArg = {
  jobId: string;
};
export type BowtieJobGetByIdApiResponse =
  /** status 200 OK */ JsonNodeBackgroundJob;
export type BowtieJobGetByIdApiArg = {
  jobId: string;
};
export type DeleteBowtieAndFiltersApiResponse = /** status 200 OK */ boolean;
export type DeleteBowtieAndFiltersApiArg = {
  id: string;
};
export type DeleteBowtieAndMoveFiltersApiResponse =
  /** status 200 OK */ boolean;
export type DeleteBowtieAndMoveFiltersApiArg = {
  id: string;
  recordId: string;
  diagramFilterDto: DiagramFilterDto;
};
export type GlobalPromptDto = {
  prompt?: string;
};
export type Control = {
  id?: string;
  name?: string;
  category?: "Hard" | "Soft";
  type?: "Preventative" | "Mitigating";
  isCritical?: boolean;
  isInitial?: boolean;
  controlType?: string;
};
export type Factor = {
  id?: string;
  name?: string;
  controls?: Control[];
};
export type EscalationFactorBarrier = {
  id?: string;
  name?: string;
};
export type EscalationFactor = {
  id?: string;
  name?: string;
  controlId?: string;
  escalationFactorBarriers?: EscalationFactorBarrier[];
};
export type Bowtie = {
  username?: string;
  term?: string;
  hazard?: string;
  risk?: string;
  causes?: Factor[];
  consequences?: Factor[];
  escalationFactors?: EscalationFactor[];
  id?: string;
};
export type ControlDto = {
  id?: string;
  name?: string;
  category?: "Hard" | "Soft";
  type?: "Preventative" | "Mitigating";
  isCritical?: boolean;
  isInitial?: boolean;
  controlType?: string;
};
export type FactorDto = {
  id?: string;
  name?: string;
  controls?: ControlDto[];
};
export type EscalationFactorBarrierDto = {
  id?: string;
  name?: string;
};
export type EscalationFactorDto = {
  id?: string;
  name?: string;
  controlId?: string;
  escalationFactorBarriers?: EscalationFactorBarrierDto[];
};
export type BowtieDto = {
  term?: string;
  hazard?: string;
  risk?: string;
  causes?: FactorDto[];
  consequences?: FactorDto[];
  escalationFactors?: EscalationFactorDto[];
};
export type DisplayFilterDto = {
  showOnlyCriticalControls?: boolean;
  showControlTypes?: boolean;
  showControlEffectiveness?: boolean;
  showControlsInSingleRow?: boolean;
};
export type DiagramFilterDto = {
  displayFilter?: DisplayFilterDto;
};
export type SuggestResponse = {
  /** Suggested text version to correct the original Bowtie Diagram with what to add, remove, or modify */
  suggestion_text: string;
};
export type ControlRequestWithId = {
  /** Control short name */
  name: string;
  /** Control category (Hard or Soft) */
  category: "Hard" | "Soft";
  /** Indicates True when this control is critical and False when supportive or not critical */
  isCritical: boolean;
  /** Indicates whether this control is required to be initially implemented */
  isInitial: boolean;
  controlType?: string;
  id: string;
  /** Control type (Preventative or Mitigating) */
  type: "Preventative" | "Mitigating";
};
export type CauseRequestWithId = {
  /** Cause short name of a material unwanted event */
  name: string;
  controls: ControlRequestWithId[];
  id: string;
};
export type ConsequenceRequestWithId = {
  /** Consequence short name of a material unwanted event */
  name: string;
  controls: ControlRequestWithId[];
  id: string;
};
export type BowtieCorrectionRequest = {
  global_prompt?: string;
  extra_prompt?: string;
  bowtie: {
    hazard: string;
    risk: string;
    causes: CauseRequestWithId[];
    consequences: ConsequenceRequestWithId[];
    term: string;
  };
  control_types?: string[];
};
export type HazardMuePair = {
  /** The operation, activity, or material that has one or more material unwanted event that could happen */
  hazard: string;
  /** List of material unwanted event associated with the hazard */
  material_unwanted_event: string[];
};
export type HazardMueRequest = {
  global_prompt?: string;
  extra_prompt?: string;
  term: string;
  hazard?: string;
};
export type ControlWithId = {
  /** Control short name */
  name: string;
  /** Control category (Hard or Soft) */
  category: "Hard" | "Soft";
  /** Indicates True when this control is critical and False when supportive or not critical */
  isCritical: boolean;
  /** Indicates whether this control is required to be initially implemented */
  isInitial: boolean;
  /** Control Subtype */
  controlType: string;
  /** Control ID */
  id: string;
  /** Indicates whether this control is a control issue */
  isControlIssues: boolean;
  /** Control type (Preventative or Mitigating) */
  type: "Preventative" | "Mitigating";
};
export type FactorId = {
  /** Factor ID */
  id: string;
  /** Factor name */
  name: string;
  /** Factor type (Cause or Consequence) */
  type: "Cause" | "Consequence";
  /** List of controls related to a factor */
  controls: ControlWithId[];
  /** Factor position */
  position: number;
};
export type Detail = {
  /** The source of a material unwanted event, whether it be an operation, activity, or material. */
  hazard: string;
  /** List of causes of a material unwanted event */
  causes: FactorId[];
  /** List of consequences of a material unwanted event */
  consequences: FactorId[];
};
export type FactorRequest = {
  global_prompt?: string;
  extra_prompt?: string;
  term: string;
  selected_MUE: string;
  cause_qty?: number;
  consequence_qty?: number;
  preventative_qty?: number;
  mitigation_qty?: number;
  control_types?: string[];
  hazard: string;
};
export type ErrorDetails = {
  status?: string;
  message: string;
  type?: string;
};
export type BackgroundJobConvertImageResponse = {
  /** The status of the background job */
  status: "CREATED" | "STAGED" | "ARCHIVED" | "RUNNING" | "FINISHED" | "FAILED";
  error: ErrorDetails;
  result?: {
    hazard: string;
    /** The Risk of the term to find the cause and consequence */
    risk: string;
    /** List of causes of a material unwanted event */
    causes: FactorId[];
    /** List of consequences of a material unwanted event */
    consequences: FactorId[];
  };
};
export type JsonNode = object;
export type JsonNodeBackgroundJob = {
  /** The status of the background job */
  status: "CREATED" | "STAGED" | "ARCHIVED" | "RUNNING" | "FINISHED" | "FAILED";
  error: ErrorDetails;
  result?: JsonNode;
};
export const {
  useGetGlobalPromptQuery,
  useLazyGetGlobalPromptQuery,
  useUpdateGlobalPromptMutation,
  useGetAllBowtiesQuery,
  useLazyGetAllBowtiesQuery,
  useSaveBowtieMutation,
  useGetStoredDiagramFiltersQuery,
  useLazyGetStoredDiagramFiltersQuery,
  useUpdateStoredDiagramFiltersMutation,
  useDeleteStoredDiagramFiltersMutation,
  useGetGeneratedDiagramFiltersQuery,
  useLazyGetGeneratedDiagramFiltersQuery,
  useUpdateGeneratedDiagramFiltersMutation,
  useDeleteGeneratedDiagramFiltersMutation,
  useBowtieSuggestPostMutation,
  useBowtieSuggestJobPostMutation,
  useBowtieHazardMueMaterialUnwantedEventsPostMutation,
  useBowtieHazardMueMaterialUnwantedEventsJobPostMutation,
  useBowtieFactorsPostQuery,
  useLazyBowtieFactorsPostQuery,
  useBowtieFactorsJobPostMutation,
  useBowtieConvertImagePostMutation,
  useGetBowtieByIdQuery,
  useLazyGetBowtieByIdQuery,
  useDeleteBowtieMutation,
  useUpdateBowtieMutation,
  useBowtieConvertImageJobIdGetQuery,
  useLazyBowtieConvertImageJobIdGetQuery,
  useBowtieJobGetByIdQuery,
  useLazyBowtieJobGetByIdQuery,
  useDeleteBowtieAndFiltersMutation,
  useDeleteBowtieAndMoveFiltersMutation,
} = injectedRtkApi;
